import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { computeExteriorUrl } from '@anewgo/utils'
import InteractiveCanvas from './InteractiveCanvas'
import { gcsURL } from '../utils/gcsUrl'

export default function InteractiveExteriorImage({
  apiKey,
  engineUrl,
  client,
  community,
  plan,
  elevation,
  selectedScheme,
  directoryName,
  colorMtd,
  colorSelections,
  viewElements,
  selectedMaterial,
  onHighlight,
  onSelect,
}) {
  const computedUrl = useMemo(
    () =>
      computeExteriorUrl(
        apiKey,
        client,
        colorMtd,
        community,
        directoryName,
        elevation,
        engineUrl,
        plan,
        selectedScheme,
        colorSelections,
        1800, // Function uses either 900px for small screen or 1800px, but we want to fix to 1800 to prevent blurry images on small screens
        true
      ),
    [
      apiKey,
      client,
      colorMtd,
      community,
      directoryName,
      elevation,
      engineUrl,
      plan,
      selectedScheme,
      colorSelections,
    ]
  )

  const allLayers = viewElements.map((element) => ({
    id: element.material.id,
    renderIndex: element.list_order ?? 1,
    image: gcsURL(`app/${directoryName}/images`, element.src),
  }))

  const availableLayers = allLayers.filter((layer) =>
    selectedScheme.scheme_elements.some(
      (element) => layer.id === element.material?.id
    )
  )

  return (
    <InteractiveCanvas
      backdropSrc={computedUrl}
      allLayers={allLayers}
      availableLayers={availableLayers}
      selectedLayer={selectedMaterial}
      onSelect={onSelect}
      onHighlight={onHighlight}
    />
  )
}

InteractiveExteriorImage.propTypes = {
  apiKey: PropTypes.string,
  engineUrl: PropTypes.string.isRequired,
  client: PropTypes.string.isRequired,
  community: PropTypes.string.isRequired,
  plan: PropTypes.string.isRequired,
  elevation: PropTypes.string.isRequired,
  selectedScheme: PropTypes.string.isRequired,
  directoryName: PropTypes.string.isRequired,
  colorMtd: PropTypes.string.isRequired,
  colorSelections: PropTypes.arrayOf(PropTypes.object).isRequired,
  viewElements: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedMaterial: PropTypes.object,
  onHighlight: PropTypes.func,
  onSelect: PropTypes.func,
}

InteractiveExteriorImage.defaultProps = {
  apiKey: '123',
  selectedMaterial: null,
  onHighlight: null,
  onSelect: null,
}
